export const navigation = [
  {
    text: 'Tổng quan',
    shortText: 'Tổng quan',
    icon: 'home',
    path: '/overview',
    items: [],
  },
  {
    text: 'Báo cáo thống kê',
    shortText: 'Báo cáo',
    icon: 'chart',
    path: '/analytics',
    items: [
      {
        text: 'Ngân sách sửa chữa 2026',
        icon: 'chart',
        description: 'Theo dõi chi phí, ngân sách còn lại và tình hình sử dụng theo đơn vị.',
        path: '/analytics-dashboard',
      },
    ],
  },
];
